import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header } from '@/components/Header';
import { LayoutDashboard, Package, Users, RefreshCw, ClipboardList, AlertOctagon, Inbox, Mail } from 'lucide-react';

export function AdminLayout() {
  const { t } = useTranslation();
  const links = [
    { to: '/admin', end: true, label: t('admin.nav.overview'), icon: LayoutDashboard, testid: 'admin-nav-overview' },
    { to: '/admin/products', label: t('admin.nav.products'), icon: Package, testid: 'admin-nav-products' },
    { to: '/admin/users', label: t('admin.nav.users'), icon: Users, testid: 'admin-nav-users' },
    { to: '/admin/sync', label: t('admin.nav.sync'), icon: RefreshCw, testid: 'admin-nav-sync' },
    { to: '/admin/requests', label: t('admin.nav.requests'), icon: Inbox, testid: 'admin-nav-requests' },
    { to: '/admin/notifications', label: t('admin.nav.notifications'), icon: Mail, testid: 'admin-nav-notifications' },
    { to: '/admin/audit', label: t('admin.nav.audit'), icon: ClipboardList, testid: 'admin-nav-audit' },
    { to: '/admin/errors', label: t('admin.nav.errors'), icon: AlertOctagon, testid: 'admin-nav-errors' },
  ];
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pn-container grid gap-6 py-8 lg:grid-cols-[220px_1fr]">
        <aside className="lg:sticky lg:top-24 h-max">
          <div className="pn-card p-3" data-testid="admin-sidebar-nav">
            <div className="px-3 py-2 text-xs font-semibold uppercase tracking-widest text-[#4A4D52]">{t('admin.title')}</div>
            <nav className="mt-1 flex flex-col">
              {links.map((l) => {
                const Icon = l.icon;
                return (
                  <NavLink
                    key={l.to}
                    to={l.to}
                    end={l.end}
                    data-testid={l.testid}
                    className={({ isActive }) =>
                      `inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition ${isActive ? 'bg-[#FBEADD] text-[#E2611C] border-l-2 border-[#E2611C]' : 'text-[#14171C] hover:bg-[#F6F8FB]'}`
                    }
                  >
                    <Icon className="h-4 w-4" /> {l.label}
                  </NavLink>
                );
              })}
            </nav>
          </div>
        </aside>
        <div><Outlet /></div>
      </div>
    </div>
  );
}
